import { useState, useEffect } from "react";
import { ColumnDef } from "types/common/Header";
import TableCellOverlay from "./TableCellOverlay";

interface Props<T extends { id: number }> {
  headers: ColumnDef<T>[];
  data: T[];
  entityType: string;
  onDelete: (entityId: string) => void;
}

const BaseBody = <T extends { id: number }>({
  headers,
  data,
  entityType,
  onDelete,
}: Props<T>) => {
  const [activeRowId, setActiveRowId] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setActiveRowId(null);
    setShowModal(false);
  }, [data]);

  const handleClick = (entityId: string) => {
    if (activeRowId === entityId) {
      setActiveRowId(null);
      setShowModal(false);
    } else {
      setActiveRowId(entityId);
      setShowModal(true);
    }
  };

  const handleCloseOverlay = () => {
    setActiveRowId(null);
    setShowModal(false);
  };

  const renderCells = (row: T) =>
    headers.map((header) => {
      const cellContent = header.cell(row);
      return (
        <td key={header.sortKey}>
          <div className="table__body-inset">{cellContent}</div>
        </td>
      );
    });

  const renderRows = () =>
    data.map((row) => {
      const entityId = row.id.toString();
      const isActive = activeRowId === entityId;
      return (
        <tr
          className="table__body-row usadmin-table__body-row"
          key={entityId}
          onClick={() => handleClick(entityId)}
          data-row-id={entityId}
        >
          {renderCells(row)}
          {isActive && (
            <TableCellOverlay
              entityId={entityId}
              showModal={showModal}
              onClose={handleCloseOverlay}
              entityType={entityType}
              onDelete={onDelete}
            />
          )}
        </tr>
      );
    });

  return <tbody>{renderRows()}</tbody>;
};

export default BaseBody;
